import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'currencyLocale'
})
export class CurrencyLocalePipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) { }

  transform(value: number | string | undefined, currencyCode?: string, display?: string | boolean | undefined, digitsInfo?: string): string | undefined {
    if (!value) {
      value = 0;
    }

    const currencyPipe: CurrencyPipe = new CurrencyPipe(this.translateService.currentLang ?? 'fr');
    return currencyPipe.transform(value, currencyCode, display, digitsInfo) ?? undefined;
  }
}
